//
// Original collection by Kjetil Midtgarden Golid
// https://github.com/kgolid/chromotome
// https://kgolid.github.io/chromotome-site/
//
export default [
  {
    name: 'cako1',
    colors: ['#000000', '#d55a3a', '#2a5c8a', '#7e7d14', '#dbdac9'],
    stroke: '#000000',
    background: '#f4e9d5',
    type: 'cako',
  },
  {
    name: 'cako2',
    colors: ['#dbdac9', '#d55a3a', '#2a5c8a', '#b47b8c', '#7e7d14'],
    stroke: '#000000',
    background: '#000000',
    type: 'cako',
  },
  {
    name: 'cako2_sub1',
    colors: ['#dbdac9', '#d55a3a', '#2a5c8a'],
    stroke: '#000000',
    background: '#000000',
    type: 'cako',
  },
  {
    name: 'cako2_sub2',
    colors: ['#dbdac9', '#d55a3a', '#7e7d14'],
    stroke: '#000000',
    background: '#000000',
    type: 'cako',
  },
];
